import React, { Component } from 'react';
import { Spin, Table, Input, Tooltip } from 'antd';
import { connect } from 'dva';
import { router } from 'umi';
import { stringify } from 'qs';

import MemberModal from '../components/MemberModal';
import Edit from '../components/EditModal';
// import BreadNav from '../../../../components/BreadNav/BreadNav';
// import { getCurrentBreadCrumbs, getIframeUrl } from '@/utils/utils';
import Container from '../../../../../components/Container';
import styles from './index.less';

const { Search } = Input;

@connect(({ tags, loading }) => ({
  loading: loading.effects['tags/fetchMemberList'],
  ...tags,
}))
class SysTagsView extends Component {
  constructor(props) {
    super(props);

    const columns = [
      {
        title: '标签名称',
        dataIndex: 'alias',
        width: '50%',
        render: record => (
          <Tooltip title={record} placement="topLeft">
            <div className="table-th-icon ellipsis">{record}</div>
          </Tooltip>
        ),
      },
      {
        title: '成员数量',
        // dataIndex: 'num',
        width: '20%',
        render: record => (
          <span className="table-action-box">
            <a
              className="table-action-edit"
              onClick={event => this.handleJumpMember({ memberVisible: true, record, event })}
            >
              {record.num}
            </a>
          </span>
        ),
      },
      {
        title: '操作',
        dataIndex: '',
        width: '30%',
        render: record => (
          <span className="table-action-box">
            <a
              className="table-action-edit"
              onClick={event => this.handleEdit({ visible: true, record, event })}
            >
              重命名
            </a>
          </span>
        ),
      },
    ];

    // 面包屑
    // const breadcrumb = getCurrentBreadCrumbs({
    //   currentUrl: {
    //     context: '系统标签',
    //     path: `/countyContacts/sysTags${window.location.search}`,
    //   },
    //   isTop: true,
    //   storekey: 'countyManagementCenterBreadcrumb',
    // });

    this.state = {
      columns,
      searchValue: '',
      // breadcrumb,
      currentPage: 1,
      editModalInfo: {
        data: {},
        visible: false,
      },
      memberVisible: false, // 显示成员modal
      tagName: '', // 当钱标签name
      pageSize: 20,
    };
  }

  componentDidMount() {
    this.getList();
  }

  getList = name => {
    const { dispatch } = this.props;
    const { currentPage, pageSize } = this.state;
    dispatch({
      type: 'tags/fetchList',
      payload: {
        page: currentPage,
        pageSize,
        name,
        type: 0,
      },
    });
  };

  handleCancelMemberModal = () => {
    this.setState(
      {
        memberVisible: false,
      },
      () => {
        this.getList();
      }
    );
  };

  handleJumpMember = ({ record }) => {
    const { id, alias: name } = record;
    router.push(
      `/countyContacts/tags/sys_user?${stringify({ currentTagId: id, currentTagName: name })}`
    );
  };
  // handleMemberModal = ({ memberVisible = false, record = {}, event } = {}) => {
  //   if (event) {
  //     event.stopPropagation();
  //   }
  //   const { dispatch } = this.props;
  //   const { id, alias } = record;
  //   dispatch({
  //     type: 'tags/fetchMemberList',
  //     payload: {
  //       tagId: id,
  //     },
  //   });
  //   this.setState({
  //     memberVisible,
  //     tagName: alias,
  //   });
  // };

  handleEdit = ({ visible = false, record = {}, event } = {}) => {
    if (event) {
      event.stopPropagation();
    }

    this.setState({
      editModalInfo: {
        data: record,
        visible,
      },
    });
  };

  handleEditTagName = ({ id, alias }) => {
    const { dispatch } = this.props;
    dispatch({
      type: 'tags/fetchEditTagName',
      payload: {
        id,
        alias,
      },
      calback: () => {
        this.handleEdit();
        this.getList();
      },
    });
  };

  handleChangeSize = (current, pageSize) => {
    const { searchValue } = this.state;
    this.setState(
      {
        currentPage: current,
        pageSize,
      },
      () => {
        this.getList(searchValue);
      }
    );
  };

  handleChangePagination = (page, pageSize, callback) => {
    const { searchValue } = this.state;
    this.setState(
      {
        currentPage: page,
        pageSize,
      },
      () => {
        if (callback && Object.prototype.toString.call(callback) === '[object Function]') {
          callback();
        } else {
          this.getList(searchValue);
        }
      }
    );
  };

  handleSearch = val => {
    this.setState({
      searchValue: val,
    });
    // this.getList(val);
    const { pageSize } = this.state;
    if (!val && !val.trim().length) {
      this.handleChangePagination(1, pageSize, this.getList);
    } else {
      this.handleChangePagination(1, pageSize, () => this.getList(val));
    }
  };

  renderTable = () => {
    const { dataSource, totalElements } = this.props;
    const { columns, currentPage } = this.state;
    const tableProps = {
      rowKey: 'id',
      columns,
      dataSource,
      pagination: {
        total: totalElements,
        // showTotal: () => <span>{`共${totalElements}条`}</span>,
        showSizeChanger: true,
        pageSizeOptions: ['20', '50', '100', '200'],
        showQuickJumper: true,
        current: currentPage,
        defaultPageSize: 20,
        onChange: this.handleChangePagination,
        onShowSizeChange: this.handleChangeSize,
      },
    };

    if (totalElements > 0) {
      tableProps.footer = () => (
        <div className="table-footer">{`共 ${totalElements} 条记录 第 ${currentPage} 页`}</div>
      );
    }
    return (
      <div className="table-wrap">
        <Table {...tableProps} />
      </div>
    );
  };

  render() {
    const { editModalInfo, memberVisible, tagName } = this.state;
    const { spinProps, loading, userList } = this.props;
    const { visible } = editModalInfo;
    const memberProps = {
      tagName,
      loading,
      userList,
      footer: null,
      handleCancel: this.handleCancelMemberModal,
    };

    return (
      <Container breStates={!0} version={2} defaultPadding>
        <div className={styles.sysTags}>
          {/* <BreadNav key="breadNav" dataSource={breadcrumb} /> */}
          <div className="content-container">
            <Spin {...spinProps}>
              <div className="header-wrap">
                <Search
                  style={{ width: 300 }}
                  placeholder="搜索标签名称"
                  onSearch={this.handleSearch}
                />
              </div>
              {this.renderTable()}
              {!!visible && (
                <Edit
                  extra="注意：系统标签名称后不可修改成员"
                  {...editModalInfo}
                  handleEdit={this.handleEdit}
                  handleEditDeptName={this.handleEditTagName}
                />
              )}
              {!!memberVisible && <MemberModal {...memberProps} />}
            </Spin>
          </div>
        </div>
      </Container>
    );
  }
}

export default SysTagsView;
